import { Box, Button, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import styled from 'styled-components'
import { default as useUploadImageMutation } from '../../../../apolloClient/mutations/uploadImage'
import Loader from '../../../../_global/Loader'
import { Header } from '../_local/styles'

const ProfilePhotoPreview = styled.img`
  border-radius: 100%;
  height: 125px;
  width: 125px;
`

interface UploadImageProps {
  userId: number
}

const UploadImage = ({ userId }: UploadImageProps) => {
  const [fileName, setFileName] = useState<string>()
  const [data, setDataForUpload] = useState<string>()
  const [image, setImage] = useState<string>()
  const [uploadAttempted, setUploadStatus] = useState<boolean>(false)

  let [uploadImageMutation, { data: uploadedImageData, loading }] = useUploadImageMutation()

  const reader = new FileReader()
  reader.onloadend = () => {
    const dataForUpload = String(reader.result).replace(/^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+)+;base64,/, '')
    setDataForUpload(dataForUpload)
  }

  const handleFileSelection = ({ target }: any) => {
    const file: File = target.files[0]
    if (file) {
      setImage(URL.createObjectURL(file))
      if (uploadAttempted) setUploadStatus(false)
      setFileName(file.name)
      reader.readAsDataURL(file)
    }
  }

  const handleImageUpload = () => {
    setUploadStatus(true)
    uploadImageMutation({
      variables: {
        input: { userId, fileName, data },
      },
    }).then(({ data: { uploadUserPhoto } }) => {
      const { name, extension } = uploadUserPhoto
      const uploadedImageURL = `http://img.paro.io/${name}.${extension}`
      setImage(uploadedImageURL)

    }).catch(() => {
      uploadedImageData = null
    })
  }

  const uploadSuccessful = uploadAttempted && !!uploadedImageData && !!uploadedImageData.uploadUserPhoto
  const uploadFailed = uploadAttempted && !!uploadedImageData && !uploadedImageData.uploadUserPhoto

  return (
    <Box mb={2}>
      <Header>Please upload a photo to complete your profile.</Header>

      {image ? <ProfilePhotoPreview src={image} /> : null}
      <input
        accept="image/*"
        type="file"
        id="contained-button-file"
        style={{ display: 'none' }}
        onChange={handleFileSelection}
      />
      {
        uploadFailed && (
          <Typography color="error">
            Error: Please try again, ensure your selected file is the appropriate type and size.
          </Typography>
        )
      }
      {
        uploadSuccessful && (
          <Typography>
            Success! Image uploaded.
          </Typography>
        )
      }
      {
        loading && (
          <Loader style={{ marginRight: 'auto' }} />
        )
      }
      {uploadAttempted ? null : image ? (
        <Box my={2}>
          <Button variant="contained" color="default" onClick={handleImageUpload} disabled={!image || !data}>
            Save image
          </Button>
        </Box>
      ) : (
          <Typography variant="caption" display="block">
            [No image selected] <br /> File Size Limit: 5MB <br /> Permitted File Types: .jpeg, .jpg, .png
          </Typography>
        )}
      <label htmlFor="contained-button-file">
        <Box my={2} mr={2}>
          <Button variant="contained" color="primary" component="span">
            Upload a new image
          </Button>
        </Box>
      </label>
    </Box>
  )
}

export default UploadImage
